
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季">
              <a-select v-model="queryParam.saiji" placeholder="请选择"
                        allowClear >
                <a-select-option v-for="(option,index) in saijiOptions" :value="option.id">{{option.name}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单位名称">
                <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
              </a-form-item>
            </a-col>


            <a-col :md="6" :sm="24">
              <a-form-item label="考试时间">
                <a-range-picker
                        v-model="time_range_moment"
                        style="width: 100%"
                        format="YYYY-MM-DD HH:mm:ss"
                        :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>

          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >
      <a-button @click="download(1)">赛事对接包和通用模板下载<a-icon type="download"/></a-button>
      <a-button @click="download(2)">中国俱乐部比赛下载<a-icon type="download"/></a-button>
      <a-button @click="download(3)">少儿精英赛模板下载<a-icon type="download"/></a-button>
      <a-button @click="download(4)">最新联赛下载<a-icon type="download"/></a-button>
    </div>

    <s-table
            ref="table"
            size="default"
            :columns="columns"
            :data="loadData"
            :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="name" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.name}}
            <br/><span style="color: #999">{{record.province}}{{record.city}}{{record.county}}</span>
            <br/>
            举办时间 {{record.saidate|timeFormat}}
          </div>
      </span>
      <span slot="status" slot-scope="text,record">

        开始报名 {{record.stime|timeFormat}}
        <br/>
        结束报名 {{record.etime|timeFormat}}
        <br/>



        <a-tag v-if="record.status==1" color="green">进行中</a-tag>
        <a-tag v-else>未进行</a-tag>
        <a-tag v-if="record.type==1" color="green">显示</a-tag>
        <a-tag v-else>不显示</a-tag>


      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleDate(record)">日程安排 ({{record.task_do}}/{{record.task_count}})</a>
          <!--<a-divider type="vertical" />-->

        </template>
      </span>
    </s-table>








  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import RSwitch from '@/components/RSwitch/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getSaiquList ,getSaiquDetail,editSaiqu,addSaiqu,getSaijiList ,getSubjectTypeOptions } from '@/api/sai'
  export default {
    name: 'KaojiSaiquList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      RSwitch,
      EditableCell,
    },
    data () {
      return {
                areaOptions,
                visible: false,
                applyVisible: false,
                saveLoading:false,
                subjectTypeOptions:[],
                formData:{
                  id:0,
                  status:1,
                  photo_service:1,
                  type:1,
                  danwei:'',
                  saidate_moment:[],
                  saidate:[],
                  time_range_moment:[],
                  time_range:[],
                  erweiimg:[],
                  areas:[],
                  pic:[],
                  pics:[],
                },
                saijiOptions:[],
                labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
                  xs: { span: 24 },
                  sm: { span: 8 },
                },
                wrapperCol: {
                  xs: { span: 24 },
                  sm: { span: 12 },
                },
                form: this.$form.createForm(this),
                mdl: {},

                // 高级搜索 展开/关闭
                advanced: false,
                // 查询参数
                queryParam: {
                  keywords:'',
                },
                // 表头
                columns: [
                  {
                    title: '#',
                    dataIndex: 'id',
                    width: '50px'
                  },
                  {
                    title: '名称',
                    dataIndex: 'name',
                    scopedSlots: { customRender: 'name' },
                  },
                  {
                    title: '状态',
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                  },
                  {
                    title: '操作',
                    dataIndex: 'action',
                    fixed: 'right',
                    width: 200,
                    scopedSlots: { customRender: 'action' },
                  }
                ],
                // 加载数据方法 必须为 Promise 对象
                loadData: parameter => {
                console.log('loadData');
      console.log(this.queryParam);
      let that= this;


      this.queryParam = Object.assign(this.queryParam,parameter);
      return getSaiquList(this.queryParam)
                      .then(res => {
                console.log('res');
      return res.data
    })
    },

      selectedRowKeys: [],
              selectedRows: [],
              cashFormData:{
        ids:[],
                to_type:'',
                price:0,
                note:'',
                count:0,
      }
    }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.getSaijiOptions();
      that.getSubjectTypeOptions();
    },
    methods: {
      moment,
      addHandle(){
        this.formData = {
          id:0,
          status:1,
          photo_service:2,
          type:1,
          saidate_moment:[],
          saidate:[],
          time_range_moment:[],
          time_range:[],
          erweiimg:[],
          areas:[],
          pic:[],
          pics:[],
        },
                this.form.resetFields();
        this.visible = true
      },
      handleCancel(){
        this.visible = false
      },
      getSaijiOptions(){
        let that = this;
        getSaijiList().then(res =>{
          that.saijiOptions = res.data.list
        })
      },
      getSubjectTypeOptions(){
        let that = this;
        getSubjectTypeOptions().then(res =>{
          that.subjectTypeOptions = res.data
        })
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleDate(record){
        const {href} = this.$router.resolve({name:'SaiDateDetail',query:{id:record.id}});
        window.open(href, '_blank');
      },
      handleEdit(record){
        let self = this
        this.visible = true
        getSaiquDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            if(res.data.area){
              res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
            }else{
              res.data.areas = [];
            }
            res.data.saidate_moment = [moment(res.data.saidate*1000),moment(res.data.saidate_end*1000)]; //moment(res.data.saidate*1000);
            res.data.time_range_moment = [moment(res.data.stime*1000),moment(res.data.etime*1000)];
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
      // 查
      onSearch() {
        let self = this;
        self.$refs.table.refresh(false)
      },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        if(self.formData.time_range_moment.length!=2){
          self.$message.error('请选择时间范围');
          return ;
        }
        if(!self.formData.subjecttype){
          self.$message.error('请选择项目配置');
          return ;
        }
        if(!self.formData.saiji){
          self.$message.error('请选择赛季');
          return ;
        }
        if(self.formData.areas.length!=3){
          self.$message.error('请选择完整地区');
          return ;
        }
        if(self.formData.saidate_moment.length!=2){
          self.$message.error('请选择比赛时间');
          return ;
        }
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            if(self.formData.id>0){

              editSaiqu({
                id:self.formData.id,
                name:values.name,
                saiji:self.formData.saiji,
                photo_service:self.formData.photo_service,
                subjecttype:self.formData.subjecttype,
                status:self.formData.status,
                type:self.formData.type,
                area:self.formData.areas[self.formData.areas.length-1],
                saidate:[self.formData.saidate_moment[0].format('YYYY-MM-DD'),self.formData.saidate_moment[1].format('YYYY-MM-DD')], //self.formData.saidate_moment.format('YYYY-MM-DD'),
                time_range:[self.formData.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),self.formData.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')],
                memberoneprice:values.memberoneprice,
                photo_service_price:values.photo_service_price,
                photo_service_allprice:values.photo_service_allprice,
                erweiimg:self.formData.erweiimg,
                pic:self.formData.pic,
                pics:self.formData.pics,
              }).then(res => {
                self.$message.success('修改成功')
                self.$refs.table.refresh(false)
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }else{
              addSaiqu({
                name:values.name,
                saiji:self.formData.saiji,
                subjecttype:self.formData.subjecttype,
                photo_service:self.formData.photo_service,
                status:self.formData.status,
                type:self.formData.type,
                area:self.formData.areas[self.formData.areas.length-1],
                saidate:[self.formData.saidate_moment[0].format('YYYY-MM-DD'),self.formData.saidate_moment[1].format('YYYY-MM-DD')], //self.formData.saidate_moment.format('YYYY-MM-DD'),
                time_range:[self.formData.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),self.formData.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')],
                memberoneprice:values.memberoneprice,
                photo_service_price:values.photo_service_price,
                photo_service_allprice:values.photo_service_allprice,
                erweiimg:self.formData.erweiimg,
                pic:self.formData.pic,
                pics:self.formData.pics,
              }).then(res => {
                self.$message.success('修改成功')
                self.$refs.table.refresh(false)
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }

          }
        })
      },

      download(index){
        let url = "https://ccago.oss-cn-hangzhou.aliyuncs.com/zip/%E8%B5%9B%E4%BA%8B%E5%AF%B9%E6%8E%A5%E5%8C%85%E5%92%8C%E9%80%9A%E7%94%A8%E6%A8%A1%E6%9D%BF.rar"
        switch (index) {
          case 2:
            url = "https://ccago.oss-cn-hangzhou.aliyuncs.com/zip/%E4%B8%AD%E5%9B%BD%E4%BF%B1%E4%B9%90%E9%83%A8%E6%AF%94%E8%B5%9B.zip"
            break
          case 3:
            url = "https://ccago.oss-cn-hangzhou.aliyuncs.com/zip/%E5%B0%91%E5%84%BF%E7%B2%BE%E8%8B%B1%E8%B5%9B%E6%A8%A1%E6%9D%BF.zip"
            break
          case 4:
            url = "https://ccago.oss-cn-hangzhou.aliyuncs.com/zip/%E6%9C%80%E6%96%B0%E8%81%94%E8%B5%9B.zip"
            break
        }

        window.open(url)
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

    },
    filters:{
    },
    watch: {
    }
  }
</script>
